import { Stack, Typography, styled, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { numberWithPoint } from '../../utils/numbers';
import { ButtonsPrimary } from '../ComponentApp/buttoms';
import Spinner from '../Spinner';
import AvatarDashboard from './AvatarDashboard';
import WalletNoAmountCard from './WalletNoAmountCard';

export const ContainerWallet = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  maxHeight: '100%',
  width: '100%',
  minHeight: '315px',
  maxWidth: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '8px 16px',
  boxSizing: 'border-box',
  cursor: 'pointer',
  overflow: 'hidden',
  flexGrow: 1,
  [theme.breakpoints.down('sm')]: {
    minHeight: '250px',
  },
}));

const WalletSummaryContainer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-around',
  width: '100%',
  marginTop: '0px',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
  },
}));

const AvatarContent = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%',
  padding: '0px',
  boxSizing: 'border-box',
  marginTop: '-8px',
}));

const TitleWallet = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  height: 'auto',
  width: '100%',
  maxWidth: '100%',
  marginTop: '12px',
}));

const AvailableBalanceTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.dark,
  fontSize: theme.typography.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  lineHeight: '126.5%',
  margin: '0px',
}));

const AvailableBalance = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: theme.typography.availableBalance.fontSize,
  fontWeight: theme.typography.h1.fontWeight,
  textAlign: 'center',
  whiteSpace: 'pre-wrap',
  lineHeight: '126.5%',
  margin: '0px',
}));

const ContainerWalletActions = styled(Stack)(({ theme }) => ({
  position: 'relative',
  isolation: 'isolate',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'start',
  alignItems: 'center',
  padding: '0px',
  boxSizing: 'border-box',
  alignSelf: 'stretch',
  margin: '0px',
  height: 'auto',
  width: '100%',
  marginTop: '12px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '32px',
  },
}));

export const WalletDashboard = ({ balanceData, loadingBalance, errorBalance }) => {
  const { user } = useSelector(state => state.auth);

  const [accessWallet, setAccessWallet] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  const handleRedirect = () => {
    if (!accessWallet) {
      return navigate('/completeregistration');
    }
    if (balanceData?.totalAmount === 0) {
      return navigate('/payments');
    }
    if (balanceData?.totalAmount >= 1) {
      return navigate('/wallet');
    }

    return navigate('/payments');
  };

  const handleRedirectToWallet = () => {
    if (!accessWallet) {
      return navigate('/completeregistration');
    }

    return navigate('/wallet');
  };

  useEffect(() => {
    if (
      user?.['custom:checkid-sign-doc'] &&
      user['custom:checkid-sign-doc'] === 'signature_success'
    ) {
      setAccessWallet(true);
    }
  }, [user]);

  if (loadingBalance || !balanceData) {
    return <Spinner />;
  }

  if (errorBalance) {
    throw new Error('Error component wallet dashboard');
  }
  return (
    <ContainerWallet onClick={handleRedirectToWallet}>
      <WalletSummaryContainer>
        <AvatarContent>
          <AvatarDashboard riskProfile={user['custom:profile'].toLowerCase()} />
        </AvatarContent>

        {balanceData && balanceData?.totalAmount !== 0 ? (
          <TitleWallet>
            <AvailableBalanceTitle>Caja Total</AvailableBalanceTitle>
            <AvailableBalance>{`$ ${numberWithPoint(
              Math.floor(balanceData.totalAmount),
            )}`}</AvailableBalance>
          </TitleWallet>
        ) : (
          <WalletNoAmountCard handleRedirect={handleRedirect} />
        )}
      </WalletSummaryContainer>

      <ContainerWalletActions>
        <ButtonsPrimary
          name='Carga aquí tu caja'
          onClick={() => handleRedirect()}
          size='xs'
          sx={{
            '& .MuiTypography-root': {
              fontSize: theme.typography.customButton.fontSize,
            },
          }}
        />
      </ContainerWalletActions>
    </ContainerWallet>
  );
};
